import { render, staticRenderFns } from "./BarChatLobby.vue?vue&type=template&id=c013cdd8&scoped=true"
import script from "./BarChatLobby.vue?vue&type=script&lang=ts"
export * from "./BarChatLobby.vue?vue&type=script&lang=ts"
import style0 from "./BarChatLobby.vue?vue&type=style&index=0&id=c013cdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c013cdd8",
  null
  
)

export default component.exports